module.exports = __webpack_public_path__ + "img/hogans-2x.c3737386.png";